/**
 * External Dependencies
 */

import 'regenerator-runtime/runtime';

/**
 * Modules
 */

import './modules/mainMenu.js';
import './modules/postTypeFilter.js';
import './modules/basicSlider.js';
import './modules/product-applications-diagram.js';
import './modules/gdprbanner.js';
import './modules/security-popup.js';

/**
 * Hide the footer CTA padding/label on pages that have a map section
 */
const footerCTA = document.getElementById('footerCTA');
if (footerCTA && document.querySelector('section.map')) {
  footerCTA.style.cssText = 'padding-top: 0!important';
  footerCTA.querySelector('span').style.cssText = 'display:none !important;';
}
